import { useTranslation } from 'react-i18next';
import { Layout } from '../../components/Layout.js';

export function PrivacyPage() {
  const { t } = useTranslation('legal');

  return (
    <Layout>
      <article className="max-w-3xl mx-auto px-4 py-12 sm:py-16 prose prose-invert prose-neutral max-w-none">
        <h1 className="text-3xl sm:text-4xl font-bold mb-3">{t('privacy.title')}</h1>
        <p className="text-sm text-neutral-500 mb-8">{t('privacy.last_updated')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('privacy.h1')}</h2>
        <p className="text-neutral-300 leading-relaxed">{t('privacy.p1')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('privacy.h2')}</h2>
        <ul className="list-disc pl-6 text-neutral-300 space-y-2">
          <li>{t('privacy.li_email')}</li>
          <li>{t('privacy.li_events')}</li>
          <li>{t('privacy.li_metrics')}</li>
          <li>{t('privacy.li_logs')}</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('privacy.h3')}</h2>
        <p className="text-neutral-300 leading-relaxed">{t('privacy.p3')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('privacy.h4')}</h2>
        <ul className="list-disc pl-6 text-neutral-300 space-y-1">
          <li>{t('privacy.sub_stripe')}</li>
          <li>{t('privacy.sub_aws')}</li>
          <li>{t('privacy.sub_cloudflare')}</li>
          <li>{t('privacy.sub_posthog')}</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('privacy.h5')}</h2>
        <p className="text-neutral-300 leading-relaxed">{t('privacy.p5')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('privacy.h6')}</h2>
        <p className="text-neutral-300 leading-relaxed">privacy@boletra.com</p>
      </article>
    </Layout>
  );
}
